
















































































import validators from '@/validators';
import Vue from 'vue';
import { CaseInfo } from '@/interfaces/donation/donationcase/caseInfo';
import { CaseEvent, CaseEventType } from '@/interfaces/donation/donationcase/caseEvent';
import { DonationCase } from '@/interfaces/donation/donationcase/donationCase';
import { Donation } from '@/interfaces/donation/donation';
import { stepV1, stepV2 } from '@/enums/donationStepOrder';
import DonationCaseFormComponent from '@/components/donationcase/DonationCaseFormComponent.vue';
import { RequestSession } from '@/interfaces/requestSession';
import { isMemoryGift } from '@/classes/DonationType';
import { DonationGuideVersion } from '@/enums/donationGuideVersion';
import StepperFlowMixin from '@/mixins/donationStepperFlowMixin';

export default Vue.extend({
  components: {
    DonationCaseFormComponent,
  },
  mixins: [StepperFlowMixin],
  props: {
    value: {
      type: Object,
      default: null,
    },
    showPrev: {
      type: Boolean,
      default: true,
    },
    compact: Boolean,
  },
  data() {
    return {
      valid: false,
      skipStep: false,
      donationCases: [],
      donationCase: {
        caseInfo: {
          additionalInfo: '',
          events: [
            {
              date: '',
              place: '',
              time: '',
              venue: '',
              type: CaseEventType.FUNERAL,
            },
            {
              date: '',
              place: '',
              time: '',
              venue: '',
              type: CaseEventType.BIRTH,
            },
            {
              date: '',
              place: '',
              time: '',
              venue: '',
              type: CaseEventType.DEATH,
            },
          ] as CaseEvent[],
          name: '',
          intermediary: null,
          recipient: null,
        } as CaseInfo,
      } as DonationCase,
      rules: {},
    };
  },
  computed: {
    steps(): typeof stepV1 | typeof stepV2 {
      return this.getDonationStepFlowVersion() == DonationGuideVersion.V1 ? stepV1 : stepV2;
    },
    donation(): Donation {
      return this.$store.state.donation;
    },
    currentStep() {
      return this.$store.state.currentStep;
    },
    requestSession(): RequestSession {
      return this.$store.state.requestSession;
    },
    isMemoryGift(): boolean {
      return this.donation && isMemoryGift(this.donation.donationType.type);
    },
  },
  watch: {
    currentStep: {
      handler(newVal, oldVal) {
        if (newVal === this.steps.CASE) {
          this.handleDonationCasesFromRequestSession();
        }
        // if skipStep is true a DonationCase has been set from the RequestSession
        if (newVal === this.steps.CASE && this.skipStep) {
          if (oldVal === this.steps.CASE + 1) {
            this.$emit('previousStep');
          } else {
            this.next();
          }
        }
        if (newVal === this.steps.CASE && !this.isMemoryGift) {
          this.$emit('removeStep', this.steps.CASE);
          if (oldVal === this.steps.CASE + 1) {
            this.$emit('previousStep');
          } else {
            this.$emit('nextStep');
          }
        } else {
          this.$emit('addStep', this.steps.CASE);
        }
      },
      immediate: true,
    },
    donationCase: {
      handler(newValue, oldValue) {
        if (newValue.intermediary) {
          this.donation.intermediary = newValue.intermediary;
          this.requestSession.intermediary = newValue.intermediary;
          this.$store.commit('updateRequestSession', this.requestSession);
        }
      },
    },
  },
  created() {
    // NOTE: This might be an issue if language is to be changed runtime
    Object.assign(this.rules, validators(this.$t('validation')));
    this.handleDonationCasesFromRequestSession();
  },
  methods: {
    handleDonationCasesFromRequestSession() {
      if (this.requestSession.donationCases && this.requestSession.donationCases.length > 0) {
        this.donationCases = this.requestSession.donationCases;
        this.donationCase = this.donationCases[0];
        this.skipStep = this.donationCases.length == 1;
      }
    },
    next() {
      if (!this.skipStep && !this.$refs.form.validate()) {
        // TODO: Break out and reuse for other form steps
        for (var i = 0; i < this.$refs.form.$children.length; i++) {
          const child = this.$refs.form.$children[i];
          if (child.valid === false) {
            this.$vuetify.goTo(child, { offset: 100 });
          }
        }
        return;
      }
      let donation: Donation = this.donation;
      donation.donationCase = this.donationCase;
      this.$store.commit('updateDonation', donation);
      this.$emit('nextStep');
    },
    t(label: string) {
      const $te = this.$te.bind(this);
      const $t = this.$t.bind(this);
      return $te(label) ? $t(label) : undefined;
    },
    getBirthEvent(donationCase: DonationCase) {
      return donationCase.caseInfo.events.find(caseEvent => caseEvent.type === CaseEventType.BIRTH);
    },
    getFuneralEvent(donationCase: DonationCase) {
      return donationCase.caseInfo.events.find(
        caseEvent => caseEvent.type === CaseEventType.FUNERAL
      );
    },
  },
});
